import { styled } from '@mui/system';
import { theme } from 'oems/theme';
import { Popover as PopoverMui } from '@mui/material';
import NoRowsOverlay from 'components/noRowsOverlay/customNoRowsOverlay';

export const Wrapper = styled('div')`
  background: ${theme.palette.background.lightGray};
  margin: 0 -24px -30px;
  padding: 20px 24px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;

  .massActions {
    width: auto;
    margin: -20px -24px 24px;
    padding: 0 24px 20px;
    background: white;
  }
`;

export const EmptyList = styled(NoRowsOverlay)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Attachment = styled('div')`
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15), 0 2px 3px rgba(0, 0, 0, 0.17);
  border-radius: 8px;
  height: 100%;
  padding: 24px 16px;
  position: relative;
  cursor: pointer;

  .actions {
    position: absolute;
    top: 8px;
    right: 8px;
    display: none;
  }

  &:hover,
  &.current {
    background: ${theme.palette.primary.focus}20;

    .actions {
      display: flex;
    }

    .filename {
      color: ${theme.palette.primary.main};
    }
  }
`;

export const Icon = styled('div')`
  width: 48px;
  height: 48px;
  background: ${theme.palette.background.default};
  border-radius: 100%;
  color: ${theme.palette.primary.main};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;

  svg {
    width: 26px;
    height: 26px;
  }
`;

export const Filename = styled('div')`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  color: ${theme.palette.secondary.main};
`;

export const Popover = styled(PopoverMui)`
  .MuiPaper-root {
    padding: 0;
  }
`;

export const DropdownContent = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: white;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.17);
  border-radius: 6px;
`;

export const Menu = styled('div')`
  padding: 8px;
  width: 212px;
`;

export const MenuButton = styled('button')`
  font-family: ${theme.typography.fontFamily};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
  height: 35px;
  padding: 0 14px;
  color: ${theme.palette.text.dark};
  border: none;
  background: white;
  font-size: 14px;
  cursor: pointer;

  &.danger {
    color: ${theme.palette.error.main};

    svg {
      color: ${theme.palette.error.main};
    }
  }

  &:hover {
    background: ${theme.palette.background.lightGray};
  }

  svg {
    width: 24px;
    height: 24px;
    margin-right: 14px;
    color: ${theme.palette.secondary.main};
  }
`;
